@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.zones

class PriceZoneDto(
    val id: Int,
    val name: String,
)
